import { useState } from 'react';
import { useIntl } from 'react-intl';
import * as Styled from './CrowdicityLoginForm.styled';

interface CrowdicityLoginFormProps {
  readonly base: string;
  readonly returnTo?: string;
  readonly sessionTimeoutMinutes: number;
  readonly authFailError?: string;
  readonly postedEmail?: string;
  readonly isAdm?: boolean;
}

export const CrowdicityLoginForm = ({
  base,
  returnTo,
  sessionTimeoutMinutes,
  authFailError,
  postedEmail,
  isAdm
}: CrowdicityLoginFormProps) => {
  const intl = useIntl();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);

  const showRememberMe = sessionTimeoutMinutes === 0 || !sessionTimeoutMinutes || sessionTimeoutMinutes >= 10_080;

  return (
    <Styled.FormContainer id="cwLogin">
      <Styled.FormTitle>
        {intl.formatMessage({ id: 'pleaseSignIn', defaultMessage: 'Please sign in' })}
      </Styled.FormTitle>
      <form
        action={`https://${base}/user/login`}
        method="post"
        id="register_form"
        autoComplete="off"
        onSubmit={() => setIsSubmitting(true)}
      >
        {authFailError && <Styled.ErrorAlert>{authFailError}</Styled.ErrorAlert>}

        <Styled.StyledField
          label={intl.formatMessage({ id: 'emailAddress', defaultMessage: 'Email address' })}
          required
          isFullWidth
          input={
            <Styled.StyledInput
              name="user_email"
              id="user_email"
              defaultValue={postedEmail ?? ''}
              required
              isFullWidth
            />
          }
        />

        <Styled.StyledField
          label={intl.formatMessage({ id: 'passwordText', defaultMessage: 'Password' })}
          required
          isFullWidth
          input={<Styled.StyledInput type="password" name="user_password" id="user_password" required isFullWidth />}
        />

        {showRememberMe && (
          <Styled.StyledCheckbox
            label={intl.formatMessage({ id: 'rememberMe', defaultMessage: 'Remember me' })}
            name="remember"
            value="1"
            checked={rememberMe}
            onChange={() => setRememberMe((prev) => !prev)}
          />
        )}

        {returnTo && <input type="hidden" name="returnTo" value={returnTo} />}

        <Styled.ButtonRow>
          <Styled.ForgotPasswordLink
            href={`/user/${isAdm ? 'admforgotpasswordform' : 'forgotpasswordform'}?returnTo=${returnTo ?? ''}`}
          >
            {intl.formatMessage({ id: 'forgottenPasswordText', defaultMessage: 'Forgotten your password?' })}
          </Styled.ForgotPasswordLink>
          <Styled.SubmitButton type="submit" priority="primary" disabled={isSubmitting} id="popUpForm_submit">
            {intl.formatMessage({ id: 'signIn', defaultMessage: 'Sign in' })}
          </Styled.SubmitButton>
        </Styled.ButtonRow>
      </form>
    </Styled.FormContainer>
  );
};
